import React, {  useState } from 'react';
import { useSelector} from 'react-redux';
import Modal from 'fast-modal-library';


/**
 * @file
 * @module Components/AdminCreateUser
 * @description AdminCreateUser est un composant permettant à un administrateur de créer un utilisateur.
 * 
 */




const apiPrefix = process.env.REACT_APP_API_PREFIX;

export default function AdminCreateUser() {
    const Numberapp = useSelector((state) => state.app.appNumber);
    const [username, setUsername] = useState('');
    const [firstname, setFirstname] = useState('');
    const [lastname, setLastname] = useState('');
    const [company, setCompany] = useState('');
    const [siret, setSiret] = useState('');
    const [chefEntreprise, setChefEntreprise] = useState(false);
    const [active, setActive] = useState(true);
    const [error, setError] = useState(null);
    const [usernameError, setUsernameError] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const regexEmail = /^[^@\s]{2,30}@[^\s@]{2,30}\.[^@\s]{2,}$/;

    const hide = () => {
        setShowModal(false);
        window.location.reload();
    };

    const handleUsernameChange = (e) => {
        setUsername(e.target.value);
        if (!regexEmail.test(e.target.value)) {
            setUsernameError("Le nom d'utilisateur doit être une adresse e-mail valide.");
        } else {
            setUsernameError('');
        }
    };
    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!regexEmail.test(username)) {
            setError("Le nom d'utilisateur doit être une adresse e-mail valide.");
            return;
        }

        if (!company.trim() || !siret.trim()) {
            setError("Le nom de société et le SIRET sont obligatoires pour l'inscription.");
            return;
        }

        const [password] = 'p';

        const formData = {
            username,
            firstname,
            password,
            lastname,
            company,
            siret,
            chefEntreprise,
            active
        };


        try {
            const response = await fetch(apiPrefix+'register', {
                method: 'POST',
                headers: {

                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    ...formData,
                appNumber: Numberapp
                })
            });

            if (response.ok) {
                
                setShowModal(true);
                setIsModalOpen(false);
            } else if (response.status === 502) {
                setError("Un compte existe déjà avec cette adresse e-mail.");
            } else if (response.status === 400) {
                try {
                    const data = await response.json();
                    setError(data.error || "Le nom de société et le SIRET sont obligatoires pour l'inscription.");
                } catch {
                    setError("Le nom de société et le SIRET sont obligatoires pour l'inscription.");
                }
            }
             else {
                console.error('Erreur lors de l\'inscription:', response.statusText);
            }
        } catch (error) {
            console.error('Erreur lors de la tentative d\'inscription:', error);
        }
    };

    const handleOverlayClick = (e) => {
        if (typeof e.target.className === 'string' && e.target.className.includes('modal-overlay')) {
            setIsModalOpen(false);
        }
    };

    return (
        <>
            <button 
                onClick={() => setIsModalOpen(true)}
                className="btn-theme"
            >
                <i className="fas fa-user-plus mr-2"></i>
                Créer un utilisateur
            </button>

            {isModalOpen && (
                <div className="modal-overlay fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4" onClick={handleOverlayClick}>
                    <div className="card-theme max-w-2xl w-full max-h-[90vh] overflow-y-auto">
                        <div className="flex justify-between items-center mb-6">
                            <h2 className="text-2xl font-bold text-theme-primary">Créer un utilisateur</h2>
                            <button 
                                className="text-gray-500 hover:text-gray-700 text-2xl font-bold"
                                onClick={() => setIsModalOpen(false)}
                            >
                                ×
                            </button>
                        </div>
                        
                        <form onSubmit={handleSubmit} className="space-y-6">
                            {error && (
                                <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg">
                                    <i className="fas fa-exclamation-triangle mr-2"></i>
                                    {error}
                                </div>
                            )}
                            
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                                <div>
                                    <label htmlFor="username" className="block text-sm font-medium text-gray-700 mb-2">
                                        <i className="fas fa-envelope mr-2 text-theme-accent"></i>
                                        Email *
                                    </label>
                                    <input
                                        type="email"
                                        id="username"
                                        value={username}
                                        onChange={handleUsernameChange}
                                        className="input-theme"
                                        placeholder="utilisateur@email.com"
                                        required
                                    />
                                    {usernameError && (
                                        <div className="text-red-600 text-sm mt-1">
                                            <i className="fas fa-exclamation-circle mr-1"></i>
                                            {usernameError}
                                        </div>
                                    )}
                                </div>
                                
                                <div>
                                    <label htmlFor="firstname" className="block text-sm font-medium text-gray-700 mb-2">
                                        <i className="fas fa-user mr-2 text-theme-accent"></i>
                                        Prénom *
                                    </label>
                                    <input
                                        type="text"
                                        id="firstname"
                                        value={firstname}
                                        onChange={(e) => setFirstname(e.target.value)}
                                        className="input-theme"
                                        placeholder="Prénom"
                                        required
                                    />
                                </div>
                                
                                <div>
                                    <label htmlFor="lastname" className="block text-sm font-medium text-gray-700 mb-2">
                                        <i className="fas fa-user mr-2 text-theme-accent"></i>
                                        Nom de famille *
                                    </label>
                                    <input
                                        type="text"
                                        id="lastname"
                                        value={lastname}
                                        onChange={(e) => setLastname(e.target.value)}
                                        className="input-theme"
                                        placeholder="Nom de famille"
                                        required
                                    />
                                </div>
                                
                                <div>
                                    <label htmlFor="company" className="block text-sm font-medium text-gray-700 mb-2">
                                        <i className="fas fa-building mr-2 text-theme-accent"></i>
                                        Entreprise *
                                    </label>
                                    <input
                                        type="text"
                                        id="company"
                                        value={company}
                                        onChange={(e) => setCompany(e.target.value)}
                                        className="input-theme"
                                        placeholder="Nom de l'entreprise"
                                        required
                                    />
                                </div>
                                
                                <div>
                                    <label htmlFor="siret" className="block text-sm font-medium text-gray-700 mb-2">
                                        <i className="fas fa-id-card mr-2 text-theme-accent"></i>
                                        SIRET *
                                    </label>
                                    <input
                                        type="text"
                                        id="siret"
                                        value={siret}
                                        onChange={(e) => setSiret(e.target.value)}
                                        className="input-theme"
                                        placeholder="Numéro SIRET"
                                        required
                                    />
                                </div>
                                
                                <div>
                                    <label htmlFor="chefEntreprise" className="block text-sm font-medium text-gray-700 mb-2">
                                        <i className="fas fa-crown mr-2 text-theme-accent"></i>
                                        Chef d'entreprise ?
                                    </label>
                                    <select
                                        id="chefEntreprise"
                                        value={chefEntreprise}
                                        onChange={(e) => setChefEntreprise(e.target.value === 'true')}
                                        className="input-theme"
                                    >
                                        <option value="false">Non</option>
                                        <option value="true">Oui</option>
                                    </select>
                                </div>
                                
                                <div>
                                    <label htmlFor="active" className="block text-sm font-medium text-gray-700 mb-2">
                                        <i className="fas fa-toggle-on mr-2 text-theme-accent"></i>
                                        Actif ?
                                    </label>
                                    <select
                                        id="active"
                                        value={active}
                                        onChange={(e) => setActive(e.target.value === 'true')}
                                        className="input-theme"
                                    >
                                        <option value="false">Non</option>
                                        <option value="true">Oui</option>
                                    </select>
                                </div>
                            </div>
                            
                            <div className="flex justify-end space-x-4 pt-6 border-t border-gray-200">
                                <button 
                                    type="button"
                                    onClick={() => setIsModalOpen(false)}
                                    className="btn-theme-secondary"
                                >
                                    <i className="fas fa-times mr-2"></i>
                                    Annuler
                                </button>
                                <button 
                                    type="submit"
                                    className="btn-theme"
                                >
                                    <i className="fas fa-user-plus mr-2"></i>
                                    Créer l'utilisateur
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
            
            {showModal && (
                <Modal contentModal="Inscription réussie !" hide={hide} />
            )}
        </>
    )
        ;
};